export default __webpack_public_path__ + "static/media/football-quiz.png.6e5db082.jpeg";